import axios from 'axios';
import { API_BASE_URL } from '@/constants';

export const fetchOwnedPets = async (token: string): Promise<OwnedPet[]> => {
  const response = await axios.get(`${API_BASE_URL}/owned-pets/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.results || response.data;
};

export const fetchOwnedPetById = async (id: number, token: string): Promise<OwnedPet> => {
  const response = await axios.get(`${API_BASE_URL}/owned-pets/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const fetchOwnedPetByUUID = async (uuid: string): Promise<OwnedPet> => {
  const response = await axios.get(`${API_BASE_URL}/owned-pets/${uuid}/public/`);
  return response.data;
};

export const createOwnedPet = async (data: Partial<OwnedPet>, token: string): Promise<OwnedPet> => {
  const response = await axios.post(`${API_BASE_URL}/owned-pets/`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const updateOwnedPet = async (id: number, data: Partial<OwnedPet>, token: string): Promise<OwnedPet> => {
  const response = await axios.patch(`${API_BASE_URL}/owned-pets/${id}/`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const deleteOwnedPet = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API_BASE_URL}/owned-pets/${id}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const downloadQRCode = async (
  id: number,
  token: string,
  format: 'png' | 'svg' = 'png',
): Promise<Blob> => {
  const response = await axios.get(`${API_BASE_URL}/owned-pets/${id}/qr_code/`, {
    params: format === 'svg' ? { file_type: 'svg' } : undefined,
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  return response.data;
};

export const uploadOwnedPetImages = async (petId: number, images: File[], token: string): Promise<OwnedPetGallery[]> => {
  const formData = new FormData();
  formData.append('pet', petId.toString());
  images.forEach((image) => {
    formData.append('images', image);
  });

  const response = await axios.post(`${API_BASE_URL}/owned-pets/${petId}/add_images/`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteOwnedPetImage = async (imageId: number, token: string): Promise<void> => {
  await axios.delete(`${API_BASE_URL}/owned-pet-gallery/${imageId}/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
